import { useState } from "react"
import { useRouter } from "next/router"

import { Typography, makeStyles } from '@material-ui/core'

import RestrictedProductList from './RestrictedProductList'
import getRestrictedProductsData from './restrictedProductsData'

const useStyles = makeStyles((theme) => ({}))

const RestrictedProducts = () => {
    const classes = useStyles()
    const router = useRouter()

    const language = router.locale

    const [open, setOpen] = useState('')

    const handleClose = (e) => {
        e.stopPropagation()
        setOpen('')
    }

    const handleExpand = (key) => {
        setOpen(key)
    }

    return (
        <div>
            <Typography>หน่วยงาน</Typography>
            <RestrictedProductList 
                data={getRestrictedProductsData(language)}
                open={open}
                onExpand={handleExpand}
                onClose={handleClose} 
            />
        </div>
    )
}

export default RestrictedProducts